/**
 * Contact.js
 *
 * JavaScript related to the Contact form functionality
 */

export default function contact ($) {
	'use strict';
	var document = window.document;

	var sendContactForm = {

		init: function () {
			$('#submit-contact').click(function (e) {
				e.preventDefault();

				let grecaptcha = window.grecaptcha;

				console.log(grecaptcha);

				grecaptcha
					.execute("6LegSN4cAAAAADDH8Mt-OgnTldtGIzmhRwtcReOx", {
						action: "contact",
					})
					.then((token) => {
						var responseArea = $('#response-area');
						let recaptchaResponse = document.getElementById("recaptcha_response");
						recaptchaResponse.value = token;
						const ajaxFormData = $("#contact-form").serialize();
						$('#response-area').toggleClass("show");
						sendContactForm.send(ajaxFormData, responseArea);
					});
			});
		},

		send: function (ajaxFormData, responseArea) {
			var data = ajaxFormData,
				url = main_script.ajaxurl;

			$.post(url, data, function (response) {
				if (response.success) {
					$('#response-area').addClass('msg-success');
					$('#contact-form')[0].reset(); //Clear form on success
				} else {
					$('#response-area').addClass('msg-error');
				}
				responseArea.html(response.data.message);
			});
		}
	};

	$(document).ready(function () {
		var body = $('body');

		// Only load on the Contact form page
		if (body.hasClass('page-template-page-contact')) {
			console.log("Contact form functions loaded");
			sendContactForm.init();
		}
	});

}
